export const SET_OPENED_MODAL = 'SET_OPENED_MODAL';
export const SET_CLOSE_BUTTON_ALTERNATIVE_BEHAVIOR = 'SET_CLOSE_BUTTON_ALTERNATIVE_BEHAVIOR';
export const RESET_OPEN_MODAL = 'RESET_OPEN_MODAL';
